module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"deviceType":"Device Type","device":{"vibrometer":"vibrometer","tiltmeter":"tiltmeter","deck":"deck","accelerometer":"accelerometer"}},"it":{"deviceType":"Tipo","device":{"vibrometer":"vibrometro","tiltmeter":"inclinometro","deck":"deck","accelerometer":"accelerometro"}}}')
  delete Component.options._Ctor
}
